import {
	Icon,
	SelectDropdown,
	SelectDropdownVariant,
} from '@lqa-frontend/ui-system';
import type {
	IDropdownItem,
	ISingleSelectDropdownProps,
} from '@lqa-frontend/ui-system';
import React from 'react';

const WORKSPACE_SELECTOR_VISIBLE_ROWS = 5;
const WORKSPACE_SELECTOR_ROW_HEIGHT = 40;
const commonProps = {
	isVirtualized: true,
	virtualListRowHeight: WORKSPACE_SELECTOR_ROW_HEIGHT,
	virtualListMaxHeight:
		WORKSPACE_SELECTOR_VISIBLE_ROWS * WORKSPACE_SELECTOR_ROW_HEIGHT,
	triggerClassName: 'w-[250px]',
	hasSameWidth: true,
	variant: SelectDropdownVariant.Select,
} satisfies Pick<
	ISingleSelectDropdownProps<IDropdownItem>,
	| 'isVirtualized'
	| 'virtualListRowHeight'
	| 'virtualListMaxHeight'
	| 'triggerClassName'
	| 'hasSameWidth'
	| 'variant'
>;

export interface IBrand extends IDropdownItem {
	id: number;
	name: string;
}

export interface IHotel extends IDropdownItem {
	id: number;
	name: string;
}

export interface IDateRange extends IDropdownItem {
	id: string;
	name: string;
}

export interface WorkspaceSelectorsProps {
	brands: IBrand[];
	hotels: IHotel[];
	selectedBrand?: IBrand | null;
	selectedHotel?: IHotel | null;
	onBrandSelect: (brand: IBrand) => void;
	onHotelSelect: (hotel: IHotel) => void;
	dateRanges?: IDateRange[];
	selectedDateRange?: IDateRange | null;
	onDateRangeSelect?: (dateRange: IDateRange) => void;
	isLoading?: boolean;
	isLoadingHotels?: boolean;
	showHotels?: boolean;
}

export function WorkspaceSelectors({
	brands,
	hotels,
	selectedBrand,
	selectedHotel,
	onBrandSelect,
	onHotelSelect,
	dateRanges,
	selectedDateRange,
	onDateRangeSelect,
	isLoading = false,
	isLoadingHotels = false,
	showHotels = true,
}: WorkspaceSelectorsProps) {
	return (
		<div className="flex flex-row flex-wrap gap-10">
			<SelectDropdown
				TEST_ID="workspace-brand-selector"
				items={brands}
				selectedItem={selectedBrand ?? null}
				onSelect={(brand) => {
					if (brand) {
						onBrandSelect(brand);
					}
				}}
				placeholder="Select brand"
				leadingIcon={<Icon name="globe" />}
				isLoadingOptions={isLoading}
				{...commonProps}
			/>

			{showHotels && (
				<SelectDropdown
					TEST_ID="workspace-hotel-selector"
					items={hotels}
					selectedItem={selectedHotel ?? null}
					onSelect={(hotel) => {
						if (hotel) {
							onHotelSelect(hotel);
						}
					}}
					placeholder="Select hotel"
					leadingIcon={<Icon name="building" />}
					isLoadingOptions={isLoadingHotels}
					{...commonProps}
				/>
			)}

			{dateRanges && (
				<div className="w-[150px]">
					<SelectDropdown
						TEST_ID="workspace-date-range-selector"
						items={dateRanges}
						selectedItem={selectedDateRange ?? null}
						onSelect={(dateRange) => {
							if (dateRange) {
								onDateRangeSelect?.(dateRange);
							}
						}}
						placeholder="Select date"
						isLoadingOptions={isLoading}
						{...commonProps}
					/>
				</div>
			)}
		</div>
	);
}
